import type { ComponentChildren, ComponentProps } from 'preact';
import { SvgIcon } from '../../../base/Icon/SvgIcon';
import type { SvgName } from '../../../base/Icon/SvgRegistry';
import styles from './JourneyPlanStepCard.module.css';

interface JourneyPlanStepCardProps extends Omit<
  ComponentProps<'a'>,
  'children' | 'className'
> {
  title: string;
  icon: SvgName;
  meta?: ComponentChildren;
  description?: ComponentChildren;
  tone?: 'default' | 'success' | 'warning';
}

export function JourneyPlanStepCard({
  title,
  icon,
  meta,
  description,
  tone = 'default',
  href = '#',
  onClick,
  ...props
}: JourneyPlanStepCardProps) {
  const handleClick: ComponentProps<'a'>['onClick'] = (event) => {
    if (href === '#') {
      event.preventDefault();
    }

    onClick?.(event);
  };

  return (
    <a {...props} href={href} onClick={handleClick} className={styles.card}>
      <span className={styles.iconWrap} aria-hidden="true">
        <SvgIcon name={icon} size={26} />
      </span>
      <span className={styles.body}>
        <span className={`${styles.title} ${styles.linkText}`}>{title}</span>
        {meta ? (
          <span className={`${styles.meta} ${styles[tone]}`}>{meta}</span>
        ) : null}
        {description ? (
          <span className={styles.description}>{description}</span>
        ) : null}
      </span>
      <SvgIcon name="chevronRight" size={14} className={styles.chevron} />
    </a>
  );
}
